import { Alert } from "@zapier/design-system";
import styles from "./Notifications.module.css";

import type { ComponentProps, ReactNode } from "react";

export type NotificationProps = ComponentProps<typeof Alert> & {
  content: ReactNode;
  id: string;
};

const Notification = ({ content, ...alertProps }: NotificationProps) => {
  return (
    <div className={styles.notification}>
      <Alert {...alertProps}>{content}</Alert>
    </div>
  );
};

export const Notifications = ({
  notifications,
}: {
  notifications: NotificationProps[];
}) => {
  return (
    <section className={styles.root}>
      {notifications.map((notification) => (
        <Notification key={notification.id} {...notification} />
      ))}
    </section>
  );
};
